var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserOutline48X48(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 26C32.9036 26 38.5 31.5964 38.5 38.5V41.5H37.5V38.5C37.5 32.1487 32.3513 27 26 27H22C15.6487 27 10.5 32.1487 10.5 38.5V41.5H9.5V38.5C9.5 31.5964 15.0964 26 22 26H26ZM24 6.5C28.9706 6.5 33 10.5294 33 15.5C32.9995 20.4702 28.9703 24.5 24 24.5C19.0297 24.5 15.0005 20.4702 15 15.5C15 10.5294 19.0294 6.5 24 6.5ZM24 7.5C19.5817 7.5 16 11.0817 16 15.5C16.0005 19.918 19.5821 23.5 24 23.5C28.28 23.5 31.7748 20.1381 31.9893 15.9111L32 15.5C32 11.0817 28.4183 7.5 24 7.5Z",
    fill: "#5D6C7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserOutline48X48);
export default __webpack_public_path__ + "static/media/user_outline_48x48.8fc664be63381814455e5e25fc1aa1b6.svg";
export { ForwardRef as ReactComponent };